import React  from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from '@ant-design/icons';

const CorporateGovernance = () => {

  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  }

    return(
        <div className="about-container">
          <div className="content-left">
          <p style={{ display: 'flex' }}>
          <ArrowLeftOutlined onClick={goBack}></ArrowLeftOutlined>Go back
        </p>
          <h1>Company’s Philosophy on Corporate Governance</h1>
      <p>
        The Company policy on Corporate Governance rests on the pillars of
        transparency, accountability, integrity, equity, and environmental
        responsibility in all facets of its operations. Good Corporate
        Governance therefore, embodies both enterprise (performance) and
        accountability (conformance).
      </p>
      <h2>Risk Management Committee</h2>
      <p>
        The primary objective of the Committee is to understand and assess
        various kinds of risks associated with the running of business and
        suggesting/implementing ways and means for eliminating/minimizing risks
        to the business of the Company and periodic review of the management
        control procedures/tools used to mitigate such risks. The composition
        of the Risk Management Committee and attendance at its meetings is
        given hereunder:
      </p>
      <table>
        <thead>
          <tr>
            <th>Members of Risk Management Committee</th>
            <th>Designation</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Mr. Yadav Bhattarai</td>
            <td>Chairman</td>
          </tr>
          <tr>
            <td>Mr. Ram Prasad Pandey</td>
            <td>Managing Director</td>
          </tr>
          <tr>
            <td>Mr. Lokendra Soti Magar</td>
            <td>Member</td>
          </tr>
          <tr>
            <td>Mrs. Susmita Khatri</td>
            <td>Member</td>
          </tr>
        </tbody>
      </table>
      <h2>Shareholders' Rights</h2>
      <p>
        Shareholders have the right to attend and vote at meetings, receive
        dividends, and access company information.
      </p>
      <h2>Financial Records</h2>
      <p>
        Brahma Jyoti Holdings Ltd. is constantly maintaining accurate financial
        records and prepared annual financial statements.
      </p>
      <h2>Transparency</h2>
      <p>
        Brahma Jyoti Holdings Ltd. has been in superlative forms regarding
        transparency as The Company Act requires transparency in books of
        accounts and audits.
      </p>
          </div>
        
        </div>
    )
}


export default CorporateGovernance;